import { ActionButtonProps, Box, ColorOptions, Form, Loader, ModBox, Spacer, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../../../components/AdminButton'
import { useEffect, useState } from 'react'
import { EmType } from '../..'
import { RootStore, useLazyApiData, useStores } from '../../../../data/store'
import { ENABLE_UPDATE_VIA_MAKER_CHECKER, MessageTypes, isAccessible } from '../../../../utils'
import { stateCodeMap, stateGstMap } from '../../../../utils/constants'
import {
  buzzCreateGroupDetails,
  buzzDetailsSearchByGroupId,
  buzzDetailsSearchBySubGroupId,
  buzzDetailsSingleEntity,
  buzzDetailsSubGrp,
  newBuzzDetailsEMSOnlyEntity,
  subGroupOnlyDetails,
} from './formData'
interface BusinessDetailsProps {
  type: string
  isValidToProceed?: (values: any, isValid: boolean) => void
  isLinkToMAS?: boolean
  selectedEntity?: any
  isMasEntity?: boolean
  showAllFields?: boolean
  isEditMode?: boolean
}

const FormBox = ({ children }: any) => {
  return <Box>{children}</Box>
}

const getOnlyDate = (dateString: string) => {
  console.log('businessDetails?.dateString', dateString)
  try {
    if (dateString !== undefined && dateString !== null) {
      const formatedDate = new Date(dateString)
      if (dateString && dateString.includes('T') && !dateString.includes('GMT')) {
        return dateString.split?.('T')?.[0]
      } else {
        return ''
      }
    } else {
      return ''
    }
  } catch (error) {
    return ''
  }
}

const BusinessDetails = ({
  type,
  isValidToProceed,
  isLinkToMAS = false,
  selectedEntity,
  isMasEntity,
  showAllFields,
  isEditMode,
}: BusinessDetailsProps) => {
  const {
    updateBusinessDetails,
    getBusinessDetails,
    getLovsFromKey,
    fetchAllLovs,
    searchFilterBy,
    updateEntity,
    searchedMasMid,
    emsParentEntityIdentificationNumber,
    getUpdatedBusinessDetails,
    isEntityPresentInMas,
    getLovsDescriptionFromKeyValue,
    fetchLov,
    getBusinessDetailsFromTaskId,
    saveState,
    resetState,
    showMdrFeePackage,
    getMdrFeePackageDetails,
    getBusinessDetailsFromGroup,
    updateGroupCamunda,
    updateSubGroupCamunda,
    updateGroupSubGroup,
    entityParentType,
    getPostUpdateBusinessData,
    getBusinessDetailsSubGroup,
    isSyncDone,
    fetchAllBusinessLines,
    businessfilledDetails,
    updateBusinessDetail,
    accessConfig,
    saveEnteredBusinessDetails,
    resetBusinessLineAndCategory,
  } = useStores((store) => ({
    updateBusinessDetails: store.onboarding.updateBusinessDetails,
    getBusinessDetails: store.getBusinessDetailsFromEntity,
    getLovsFromKey: store.getLovsFromKey,
    fetchAllLovs: store.fetchAllLovs,
    searchFilterBy: store.onboarding.searchFilterBy,
    updateEntity: store.updateEntity,
    searchedMasMid: store.onboarding.searchedMasMid,
    emsParentEntityIdentificationNumber: store.onboarding.emsParentEntityIdentificationNumber,
    getUpdatedBusinessDetails: store.onboarding.getUpdatedBusinessDetails,
    isEntityPresentInMas: store.onboarding.isEntityPresentInMas,
    getLovsDescriptionFromKeyValue: store?.getLovsDescriptionFromKeyValue,
    fetchLov: store.fetchLov,
    fetchAllBusinessLines: store.fetchAllBusinessLines,
    getBusinessDetailsFromTaskId: store.getBusinessDetailsFromTaskId,
    saveState: store.onboarding.saveState,
    resetState: store.onboarding.resetState,
    getBusinessDetailsFromGroup: store.getBusinessDetailsFromGroup,
    updateGroupCamunda: store.updateGroupCamunda,
    updateSubGroupCamunda: store.updateSubGroupCamunda,
    updateGroupSubGroup: store.updateGroupSubGroup,
    showMdrFeePackage: store.getIsParentEntityHasFeePackage,
    getMdrFeePackageDetails: store.getMdrFeePackageDetails,
    entityParentType: store.onboarding.entityParentType,
    getPostUpdateBusinessData: store.getPostUpdateBusinessData,
    getBusinessDetailsSubGroup: store.getBusinessDetailsSubGroup,
    isSyncDone: store.onboarding.isSyncDone,
    // fetchProgramCategoryDetails: store.fetchProgramCategoryDetails,
    businessfilledDetails: store.onboarding.businessDetail,
    updateBusinessDetail: store.onboarding.updateBusinessDetail,
    accessConfig: store.user.getAccessConfig(['entity_management_service', 'ems_config']),
    saveEnteredBusinessDetails: store.onboarding.saveEnteredBusinessDetails,
    resetBusinessLineAndCategory: store.resetBusinessLineAndCategory,
  }))

  console.log('===> BusinessDetails :', type, searchFilterBy, isLinkToMAS)
  const [getAllLovs, getLovHandler] = useLazyApiData(fetchAllLovs)
  const [getSingleLov, getSingleLovHandler] = useLazyApiData(fetchLov)

  const [updateEntityApi, updateEntityHandler] = useLazyApiData(updateEntity)
  const [fetchAllBusinessLinesApi, { state: fetchAllBusinessLinesHandlerApiState }] =
    useLazyApiData(fetchAllBusinessLines)
  const [updateGroupCamundaApi, updateGroupCamundaHandler] = useLazyApiData(updateGroupCamunda)
  const [updateSubGroupCamundaApi, updateSubGroupCamundaHandler] = useLazyApiData(updateSubGroupCamunda)

  const [updateGroupSubGroupApi, updateGroupSubGroupHandler] = useLazyApiData(updateGroupSubGroup)

  const [isEdit, setEditMode] = useState(false)
  const [businessDetails, setBusinessDetails] = useState({})
  // const [isPharmacyCase, setIsPharmacyCase] = useState(false)
  const [dummyValue, setDummyValue] = useState('initDummy')

  const [mccCode, setMccCode] = useState('')
  const [isValidData, setIsValidData] = useState(false)
  const [mdrPackageDetails, setMdrPackageDetails] = useState('')
  const [businessChannelSelected, setBusinessChannelSelected] = useState('')

  const [isInheritFromParentFeePackage, setInheritFromParentFeePackage] = useState(false)
  const [isAllLovsCalled, setIsAllLovsCalled] = useState(false)

  useEffect(() => {
    if (fetchAllBusinessLinesHandlerApiState === 'fulfilled') {
      if (
        selectedEntity === undefined &&
        (type === EmType.createSingleEntity || type === EmType.createGroup || type === EmType.createSubGroup) &&
        !isLinkToMAS &&
        saveEnteredBusinessDetails
      ) {
        const data = getBusinessDetails(selectedEntity, type)
        setBusinessDetails(Array.isArray(data) ? data[0] : data)
      }
    }
    if (
      selectedEntity === undefined &&
      (type === EmType.createGroup || type === EmType.createSubGroup) &&
      !isLinkToMAS &&
      saveEnteredBusinessDetails
    ) {
      const data = getBusinessDetails(selectedEntity, type)
      setBusinessDetails(Array.isArray(data) ? data[0] : data)
    }
  }, [
    fetchAllBusinessLinesHandlerApiState,
    getBusinessDetails,
    isLinkToMAS,
    saveEnteredBusinessDetails,
    selectedEntity,
    type,
  ])

  useEffect(() => {
    if (selectedEntity && selectedEntity.id) {
      const data = getBusinessDetails(selectedEntity.id, type)
      setBusinessDetails(Array.isArray(data) ? data[0] : data)
      setMccCode(Array.isArray(data) ? data?.[0]?.mccCode : data?.mccCode)
    } else if (searchedMasMid?.length > 0) {
      const data = getBusinessDetails(searchedMasMid, type)
      setBusinessDetails(Array.isArray(data) ? data[0] : data)
      setMccCode(Array.isArray(data) ? data?.[0]?.mccCode : data?.mccCode)
    } else if (selectedEntity && selectedEntity?.identificationNumber && searchFilterBy === 'Group ID') {
      const data = getBusinessDetailsFromGroup(selectedEntity.identificationNumber)
      setBusinessDetails(data)
    } else if (selectedEntity && selectedEntity?.[0]?.identificationNumber && searchFilterBy === 'SubGroup ID') {
      const data = getBusinessDetailsSubGroup(selectedEntity?.[0]?.identificationNumber)
      setBusinessDetails(data)
    } else if (type === EmType.applicationQueue && selectedEntity && selectedEntity?.applicationId?.length > 0) {
      const data = getBusinessDetailsFromTaskId(selectedEntity.applicationId)
      setBusinessDetails(Array.isArray(data) ? data[0] : data)
      if (selectedEntity?.requestType && selectedEntity?.requestType === 'MERCHANT') {
        setMccCode(Array.isArray(data) ? data?.[0]?.mccCode : data?.mccCode)
      }
    }
  }, [
    getBusinessDetails,
    getBusinessDetailsFromGroup,
    getBusinessDetailsFromTaskId,
    getBusinessDetailsSubGroup,
    searchFilterBy,
    searchedMasMid,
    selectedEntity,
    type,
    isSyncDone,
  ])

  useEffect(() => {
    if (
      updateEntityHandler.state === 'fulfilled' ||
      updateEntityHandler.state === 'rejected' ||
      updateGroupSubGroupHandler.state === 'fulfilled' ||
      updateGroupSubGroupHandler.state === 'rejected'
    ) {
      setEditMode(false)
      if (updateEntityHandler.state === 'fulfilled') {
        if (selectedEntity && selectedEntity.id) {
          const data = getPostUpdateBusinessData(
            updateEntityHandler?.data?.data?.legalName,
            updateEntityHandler?.data?.data?.businessName,
          )
          setBusinessDetails(Array.isArray(data) ? data[0] : data)
          setMccCode(Array.isArray(data) ? data?.[0]?.mccCode : data?.mccCode)
        }
      } else if (updateEntityHandler.state === 'rejected') {
        resetState()
      }
      if (updateGroupSubGroupHandler.state === 'fulfilled') {
        if (selectedEntity && selectedEntity?.identificationNumber && searchFilterBy === 'Group ID') {
          const data = getPostUpdateBusinessData(
            updateGroupSubGroupHandler?.data?.data?.legalName,
            updateGroupSubGroupHandler?.data?.data?.brandName,
          )
          setBusinessDetails(Array.isArray(data) ? data[0] : data)
        } else if (selectedEntity && selectedEntity?.[0]?.identificationNumber && searchFilterBy === 'SubGroup ID') {
          const data = getPostUpdateBusinessData(
            updateGroupSubGroupHandler?.data?.data?.legalName,
            updateGroupSubGroupHandler?.data?.data?.brandName,
          )
          setBusinessDetails(Array.isArray(data) ? data[0] : data)
        }
      } else if (updateGroupSubGroupHandler.state === 'rejected') {
        resetState()
      }
    }
  }, [
    getPostUpdateBusinessData,
    resetState,
    searchFilterBy,
    selectedEntity,
    updateEntityHandler?.data?.data?.businessName,
    updateEntityHandler?.data?.data?.legalName,
    updateEntityHandler.state,
    updateGroupSubGroupHandler?.data?.data?.brandName,
    updateGroupSubGroupHandler?.data?.data.businessName,
    updateGroupSubGroupHandler?.data?.data?.legalName,
    updateGroupSubGroupHandler.state,
  ])

  // const primaryAddr1ToolInfo = ''
  // const primaryAddr2ToolInfo = ''
  const keysArray = [
    'State',
    'OwnershipType',
    'BusinessType',
    'IndustryType',
    'BizCategory',
    'SetupLevel',
    'BusinessChannel',
    'YearsInBusiness',
    'PremiseType',
    'DailyTransactionValue',
    'DailyTxnNumber',
    'MerchantCategory',
    'GSTDealerCategory',
    'StoreType',
    'ProgramCategory',
  ]

  const masKeysArray1 = [
    'MerchantLevel',
    'OwnerType',
    'Status',
    'DailyTransactionValue',
    'DailyTxnNumber',
    'StoreType',
    'PremiseType',
    'YearsInBusiness',
    'AnnualRevenueSegment',
    'OwnershipType',
    'BusinessChannel',
    'SetupLevel',
    'MarketPlace',
    'MerchantCategory',
    'GSTDealerCategory',
  ]

  useEffect(() => {
    if (getLovHandler.state === 'fulfilled' && isLinkToMAS && !isAllLovsCalled) {
      const masKeysArray2 = [
        'BusinessType', //'typeOfBusiness',
        'AcctPostingType',
        'AccountType',
        'SettlementStatus',
        'SetupCompleteInd',
        'DeviceStatus',
        'State',
        'IndustryType',
        'BizCategory',
        'ProgramCategory',
        'SettlementFrequency',
      ]
      getAllLovs(...masKeysArray2)
      setIsAllLovsCalled(true)
    }
  }, [getAllLovs, getLovHandler.state, isAllLovsCalled, isLinkToMAS])

  useEffect(() => {
    if (type !== EmType.createSubGroup) {
      resetBusinessLineAndCategory()
      if (!isLinkToMAS) {
        getAllLovs(...keysArray)
      } else {
        getAllLovs(...masKeysArray1)
      }
      getSingleLov('MDRPackageId')
    }
    if (type !== EmType.createGroup && type !== EmType.createSubGroup) {
      fetchAllBusinessLinesApi()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // console.log('BusinessDetails: ', businessDetails, selectedEntity)

  const onEditPress = () => {
    setEditMode(true)
    saveState()
  }
  const onEditCancelPress = () => {
    setEditMode(false)
    setDummyValue('cancelDummy')
    resetState()
    // setIsResetProgramList(true)
  }
  const onSavePress = () => {
    if (selectedEntity && selectedEntity.id) {
      const data = getUpdatedBusinessDetails(businessDetails, selectedEntity.id, searchFilterBy)
      updateEntityApi(selectedEntity?.id, 'businessProfile', data)
    } else if (selectedEntity && selectedEntity.identificationNumber && searchFilterBy === 'Group ID') {
      const data = getUpdatedBusinessDetails(businessDetails, selectedEntity.identificationNumber, searchFilterBy)
      if (ENABLE_UPDATE_VIA_MAKER_CHECKER) {
        updateGroupCamundaApi(selectedEntity?.identificationNumber, 'businessProfile', data)
      } else {
        updateGroupSubGroupApi({ identificationNumber: selectedEntity?.identificationNumber, type: 'GROUP', ...data })
      }
    } else if (selectedEntity && selectedEntity?.[0]?.identificationNumber && searchFilterBy === 'SubGroup ID') {
      const data = getUpdatedBusinessDetails(businessDetails, selectedEntity?.[0]?.identificationNumber, searchFilterBy)
      if (ENABLE_UPDATE_VIA_MAKER_CHECKER) {
        updateSubGroupCamundaApi(selectedEntity?.[0]?.identificationNumber, 'businessProfile', data)
      } else {
        updateGroupSubGroupApi({
          identificationNumber: selectedEntity?.[0]?.identificationNumber,
          type: 'SUBGROUP',
          ...data,
        })
      }
    }
  }

  const actionButtons = ({ values, isCurrentFormValid }: ActionButtonProps) => {
    if (type === EmType.Search && isEdit) {
      updateBusinessDetails(values, type)
    }
    if (isCurrentFormValid && !saveEnteredBusinessDetails) {
      updateBusinessDetails(values, type)
    }
    // if (values?.mccCode?.length > 0 && values?.mccCode?.length <= 4) {
    //   setIsPharmacyCase(values?.mccCode === '5912')
    // }

    if (values?.ownershipType?.length > 0) {
      updateBusinessDetail('ownershipType', values?.ownershipType)
    }

    if (
      values?.gstNumber &&
      values?.stateUt &&
      values?.gstNumber?.length > 0 &&
      values?.stateUt?.length > 0 &&
      !!values?.gstCategory &&
      values?.gstCategory?.toString()?.toLowerCase() !== 'unregistered' &&
      values?.gstCategory?.toString()?.toLowerCase() !== 'na' &&
      isCurrentFormValid
    ) {
      const stateCode = stateCodeMap[values.stateUt]
      const stateGstCode = stateGstMap[stateCode]
      const isValidGst = values?.gstNumber?.startsWith(stateGstCode)
      if (!isValidGst && !isLinkToMAS) {
        if ((type !== EmType.Search && type !== EmType.applicationQueue) || isEdit) {
          RootStore.message.setMessage('Entered GST number does not match with selected State', MessageTypes.ERROR)
        }
        isCurrentFormValid = false
      }
    }
    if (values?.inheritParentFeePackage !== '') {
      setInheritFromParentFeePackage(values?.inheritParentFeePackage === 'Yes')
    }
    if (
      type !== EmType.Search &&
      values?.mccCodeComponent &&
      (values?.mccCodeComponent?.mccCode === undefined || values?.mccCodeComponent?.mccCode === '')
    ) {
      isCurrentFormValid = false
    }
    if (values?.businessChannel?.length > 0) {
      setBusinessChannelSelected(values?.businessChannel)
    }
    setIsValidData(isCurrentFormValid)

    isValidToProceed && isValidToProceed(values, isCurrentFormValid)
    if (isCurrentFormValid) {
      saveState()
    }
  }

  const getForm = (type: string) => {
    return type === EmType.createSubGroup
      ? buzzDetailsSubGrp(true)
      : type === EmType.Search && searchFilterBy !== 'Group ID' && searchFilterBy !== 'SubGroup ID'
      ? isLinkToMAS
        ? buzzDetailsSingleEntity(
            false,
            isEdit,
            true,
            getLovsFromKey,
            selectedEntity,
            mccCode,
            getOnlyDate(businessDetails?.merchantOtpDate),
            getOnlyDate(businessDetails?.deviceOtpDate),
            businessDetails?.jioGstAcceptanceTs,
            businessDetails?.inheritParentFeePackage ? 'Yes' : 'No',
            mdrPackageDetails,
            type,
            businessDetails?.businessLine,
            businessDetails?.businessCategory,
          )
        : newBuzzDetailsEMSOnlyEntity(
            isEdit,
            getLovsFromKey,
            mccCode,
            mdrPackageDetails,
            true,
            getMdrFeePackageDetails(emsParentEntityIdentificationNumber),
            isInheritFromParentFeePackage,
            businessDetails?.businessLine,
            businessDetails?.businessCategory,
            entityParentType === 'Entity',
            businessChannelSelected,
            selectedEntity,
            type,
            isMasEntity,
            showAllFields,
          )
      : type === EmType.Search && searchFilterBy === 'Group ID'
      ? buzzDetailsSearchByGroupId(isEdit, getLovsFromKey)
      : type === EmType.Search && searchFilterBy === 'SubGroup ID'
      ? buzzDetailsSearchBySubGroupId(isEdit, getLovsFromKey)
      : type === EmType.createSingleEntity
      ? isLinkToMAS
        ? buzzDetailsSingleEntity(
            false,
            !isLinkToMAS,
            isLinkToMAS,
            getLovsFromKey,
            selectedEntity,
            mccCode,
            businessDetails?.merchantOtpDate,
            businessDetails?.deviceOtpDate,
            businessDetails?.jioGstAcceptanceTs,
            businessDetails?.inheritParentFeePackage ? 'Yes' : 'No',
            mdrPackageDetails,
            type,
            businessDetails?.businessLine,
            businessDetails?.businessCategory,
          )
        : newBuzzDetailsEMSOnlyEntity(
            true,
            getLovsFromKey,
            mccCode,
            mdrPackageDetails,
            true,
            getMdrFeePackageDetails(emsParentEntityIdentificationNumber),
            isInheritFromParentFeePackage,
            businessDetails?.businessLine,
            businessDetails?.businessCategory,
            entityParentType === 'Entity',
            businessChannelSelected,
            selectedEntity,
            type,
            isMasEntity,
            showAllFields,
          )
      : type === EmType.applicationQueue &&
        selectedEntity &&
        selectedEntity?.requestType &&
        selectedEntity?.requestType === 'SUBGROUP'
      ? subGroupOnlyDetails(false)
      : type === EmType.applicationQueue &&
        selectedEntity &&
        selectedEntity?.requestType &&
        selectedEntity?.requestType === 'MERCHANT'
      ? newBuzzDetailsEMSOnlyEntity(
          false,
          getLovsFromKey,
          mccCode,
          mdrPackageDetails,
          true,
          getMdrFeePackageDetails(emsParentEntityIdentificationNumber),
          isInheritFromParentFeePackage,
          businessDetails?.businessLine,
          businessDetails?.businessCategory,
          entityParentType === 'Entity',
          businessChannelSelected,
          selectedEntity,
          type,
          isMasEntity,
          showAllFields,
        )
      : buzzCreateGroupDetails(
          type === EmType.applicationQueue ? false : true,
          type,
          getLovsFromKey,
          {
            originalData: businessDetails?.primaryAddress1,
            maker: 'makerDatacomeshere',
            updatedOn: businessDetails?.createdAt,
          },
          {
            originalData: businessDetails?.primaryAddress2,
            maker: 'makerDatacomeshere',
            updatedOn: businessDetails?.createdAt,
          },
          {
            originalData: businessDetails?.pincode,
            maker: 'makerDatacomeshere',
            updatedOn: businessDetails?.createdAt,
          },
          {
            originalData: businessDetails?.businessBrandName,
            maker: 'makerDatacomeshere',
            updatedOn: businessDetails?.createdAt,
          },
          {
            originalData: businessDetails?.city,
            maker: 'makerDatacomeshere',
            updatedOn: businessDetails?.createdAt,
          },
          {
            originalData: businessDetails?.stateUt,
            maker: 'makerDatacomeshere',
            updatedOn: businessDetails?.createdAt,
          },
        )
  }

  // const getFormData = useMemo(() => getForm(type), [getForm, type])

  return (
    <>
      <ModBox f={1} show={getLovHandler?.state === 'pending'} alignItems={'center'} justifyContent={'center'}>
        <Loader type={'large'} color="PRIMARY" />
      </ModBox>
      <ModBox
        nativeID="vertical-scroll"
        show={getLovHandler?.state !== 'pending'}
        f={1}
        overflow={'auto'}
        ph={40}
        pv={40}
        backgroundColor={'WHITE'}
        h={'90%'}>
        <Box pointerEvents={isEditMode ? 'auto' : 'none'}>
          <ModBox direction="row">
            <Box direction="row" w={'100%'} justifyContent={'space-between'}>
              <Box direction="row">
                <Text title={'Business Details'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
                <ModBox
                  show={false}
                  backgroundColor={'#FBF6EC' as ColorOptions}
                  borderRadius={2}
                  padding={4}
                  marginLeft={16}>
                  <Text
                    title={'Below information is fetched from MAS.'}
                    color={'#A97425' as ColorOptions}
                    fontSize={12}
                    fontFamily={'jiotype-medium'}
                    fontStyle={'italic'}
                  />
                </ModBox>
              </Box>
              <ModBox show={type === EmType.Search && !isEntityPresentInMas(selectedEntity?.id)}>
                <ModBox show={isEdit} direction={'row'}>
                  <ButtonNew
                    type={'secondarySmall'}
                    borderWidth={1}
                    title={'Cancel'}
                    borderColor={'#0070B6'}
                    borderRadius={4}
                    onPress={onEditCancelPress}
                  />
                  <Spacer size={16} direction={'horizontal'} />
                  <ButtonNew
                    height={32}
                    borderWidth={1}
                    title={'Save Changes'}
                    borderColor={'#0070B6'}
                    borderRadius={4}
                    onPress={onSavePress}
                    disabled={!isValidData}
                    color={'#0070B6'}
                    isLoading={
                      updateEntityHandler?.state === 'pending' || updateGroupSubGroupHandler?.state === 'pending'
                    }
                    loadingColor={'WHITE'}
                    type={'primary'}
                  />
                </ModBox>
                <ModBox
                  show={
                    !isEdit &&
                    type === EmType.Search &&
                    !isEntityPresentInMas(selectedEntity?.id) &&
                    isAccessible(accessConfig, 'create')
                  }>
                  <ButtonNew
                    type={'secondaryIconSmall'}
                    borderWidth={1}
                    title={'Edit'}
                    borderColor={'#0070B6'}
                    borderRadius={4}
                    icon="EDIT"
                    onPress={onEditPress}
                  />
                </ModBox>
              </ModBox>
            </Box>
          </ModBox>
          <ModBox marginTop={32}>
            <Form
              formData={getForm(type)}
              actionButtons={actionButtons}
              allTouched={type === EmType.Search && isEdit}
              initialValues={
                type === EmType.createGroup
                  ? {
                      legalEntityName: businessDetails?.legalEntityName ?? '',
                      businessBrandName: businessDetails?.businessBrandName ?? '',
                      primaryAddress1: businessDetails?.primaryAddress1 ?? '',
                      primaryAddress2: businessDetails?.primaryAddress2 ?? '',
                      pincode: businessDetails?.pincode ?? '',
                      city: businessDetails?.city ?? '',
                      stateUt: getLovsDescriptionFromKeyValue('State', businessDetails?.stateUt) ?? '',
                    }
                  : type === EmType.createSubGroup
                  ? {
                      legalEntityName: businessDetails?.legalEntityName ?? '',
                      businessBrandName: businessDetails?.businessBrandName ?? '',
                    }
                  : type === EmType.Search ||
                    (type === EmType.createSingleEntity && isLinkToMAS) ||
                    type === EmType.applicationQueue ||
                    (selectedEntity === undefined &&
                      type === EmType.createSingleEntity &&
                      !isLinkToMAS &&
                      businessDetails?.legalEntityName !== 'NA')
                  ? {
                      legalEntityName: businessDetails?.legalEntityName ?? '',
                      businessBrandName: businessDetails?.businessBrandName ?? '',
                      ownershipType:
                        getLovsDescriptionFromKeyValue('OwnershipType', businessDetails?.ownershipType) ?? '',
                      businessChannel:
                        getLovsDescriptionFromKeyValue('BusinessChannel', businessDetails?.businessChannel) ?? '',
                      setupLevel: getLovsDescriptionFromKeyValue('SetupLevel', businessDetails?.setupLevel) ?? '',
                      premiseType: getLovsDescriptionFromKeyValue('PremiseType', businessDetails?.premiseType) ?? '',
                      businessPAN: businessDetails?.businessPAN ?? '',
                      webAddress: businessDetails?.webAddress ?? '',
                      storeType: getLovsDescriptionFromKeyValue('StoreType', businessDetails?.storeType) ?? '',
                      businessType: getLovsDescriptionFromKeyValue('OwnerType', businessDetails?.ownerType) ?? '',
                      yearsOfBusiness:
                        getLovsDescriptionFromKeyValue('YearsInBusiness', businessDetails?.yearsOfBusiness) ?? '',
                      dailyTransactionValue:
                        getLovsDescriptionFromKeyValue(
                          'DailyTransactionValue',
                          businessDetails?.dailyTransactionValue,
                        ) ?? '',
                      dailyTransactionVolume:
                        getLovsDescriptionFromKeyValue('DailyTxnNumber', businessDetails?.dailyTransactionVolume) ?? '',
                      merchantOtpDate: businessDetails?.merchantOtpDate ?? '',
                      deviceOtpDate: businessDetails?.deviceOtpDate ?? '',
                      mobileNumber: businessDetails?.mobileNumber ?? '',
                      // mccCode: businessDetails?.mccCode ?? '',
                      // businessCategory: getLovsDescriptionFromKeyValue('BizCategory', businessDetails?.businessCategory) ?? businessDetails?.businessCategory ?? '',
                      // businessLine: getLovsDescriptionFromKeyValue('BizLine', businessDetails?.businessLine) ?? businessDetails?.businessLine ?? '',
                      pharmacistName: businessDetails?.pharmacistName ?? '',
                      pharmacyCouncilNumber: businessDetails?.pharmacyCouncilNumber ?? '',
                      primaryAddress1: businessDetails?.primaryAddress1 ?? '',
                      primaryAddress2: businessDetails?.primaryAddress2 ?? '',
                      pincode: businessDetails?.pincode ?? '',
                      city: businessDetails?.city ?? '',
                      stateUt: getLovsDescriptionFromKeyValue('State', businessDetails?.stateUt) ?? '',
                      businessLatitude: businessDetails?.businessLatitude ?? '',
                      businessLongitude: businessDetails?.businessLongitude ?? '',
                      gstCategory:
                        getLovsDescriptionFromKeyValue('MerchantCategory', businessDetails?.gstCategory) ?? '',
                      gstDealerCategory:
                        getLovsDescriptionFromKeyValue('GSTDealerCategory', businessDetails?.gstDealerCategory) ?? '',
                      typeOfBusiness:
                        getLovsDescriptionFromKeyValue('BusinessType', businessDetails?.typeOfBusiness) ?? '',
                      gstNumber: businessDetails?.gstNumber ?? '',
                      dateOfExpiry: businessDetails?.dateOfExpiry ?? '',
                      jioGstAcceptanceTs: businessDetails?.jioGstAcceptanceTs ?? '',
                      inheritParentFeePackage: businessDetails?.inheritParentFeePackage === true ? 'Yes' : 'No',
                      mdrPackageId: businessDetails?.feePackageId ?? '',
                      mdrPackageDetails: businessDetails?.feePackageName ?? '',
                      dummyHiddenView: `${dummyValue}_${isEdit}`,
                      country: businessDetails?.country,
                    }
                  : type === EmType.Search && searchFilterBy === 'Group ID'
                  ? {
                      legalEntityName: businessDetails?.legalEntityName ?? '',
                      businessBrandName: businessDetails?.businessBrandName ?? '',
                      primaryAddress1: businessDetails?.primaryAddress1 ?? '',
                      primaryAddress2: businessDetails?.primaryAddress2 ?? '',
                      pincode: businessDetails?.pincode ?? '',
                      city: businessDetails?.city ?? '',
                      stateUt: getLovsDescriptionFromKeyValue('State', businessDetails?.stateUt) ?? '',
                    }
                  : type === EmType.Search && searchFilterBy === 'SubGroup ID'
                  ? {
                      legalEntityName: businessDetails?.legalEntityName ?? '',
                      businessBrandName: businessDetails?.businessBrandName ?? '',
                    }
                  : {
                      legalEntityName: '',
                      businessBrandName: '',
                      ownershipType: '',
                      businessChannel: '',
                      setupLevel: '',
                      premiseType: '',
                      businessPAN: '',
                      webAddress: '',
                      storeType: '',
                      yearsOfBusiness: '',
                      dailyTransactionValue: '',
                      dailyTransactionVolume: '',
                      merchantOtpDate: '',
                      deviceOtpDate: '',
                      // mccCode: '',
                      // businessCategory: '',
                      // businessLine: '',
                      pharmacistName: '',
                      pharmacyCouncilNumber: '',
                      primaryAddress1: '',
                      primaryAddress2: '',
                      pincode: '',
                      city: '',
                      stateUt: '',
                      businessLatitude: '',
                      businessLongitude: '',
                      gstCategory: '',
                      gstDealerCategory: '',
                      typeOfBusiness: '',
                      gstNumber: '',
                      dateOfExpiry: '',
                      jioGstAcceptanceTs: '',
                      inheritParentFeePackage: '',
                      mdrPackageId:
                        isInheritFromParentFeePackage &&
                        getMdrFeePackageDetails(emsParentEntityIdentificationNumber)?.id?.length > 0
                          ? getMdrFeePackageDetails(emsParentEntityIdentificationNumber)?.id
                          : '',
                      mdrPackageDetails: '',
                      dummyHiddenView: isEdit,
                    }
              }
              container={FormBox}
            />
          </ModBox>
        </Box>
      </ModBox>
    </>
  )
}

export { BusinessDetails }
